import { render, staticRenderFns } from "./slips.vue?vue&type=template&id=32f4fa58&"
import script from "./slips.vue?vue&type=script&lang=js&"
export * from "./slips.vue?vue&type=script&lang=js&"
import style0 from "./slips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports